import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { AlertTriangle, Loader2 } from 'lucide-react'

interface PaymentModalLoadFallbackProps {
  error: unknown
  onCancel: () => void
  onRetry: () => void
  open: boolean
}

/** Pay Now's stand-in while its code loads, offering Cancel, and Try Again when the load failed. */
export function PaymentModalLoadFallback({
  error,
  onCancel,
  onRetry,
  open,
}: PaymentModalLoadFallbackProps) {
  if (!open) {
    return null
  }

  return (
    <Dialog
      modal
      open
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onCancel()
        }
      }}
    >
      <DialogContent size="small" spacing="compact">
        <DialogHeader>
          <DialogTitle>Pay Now</DialogTitle>
          <DialogDescription>
            {error
              ? 'Payment options could not be loaded. Check your connection and try again.'
              : 'Preparing secure payment options.'}
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-3 rounded-md border bg-muted/40 p-3 text-sm text-muted-foreground">
          {error ? (
            <AlertTriangle className="size-4 text-destructive" />
          ) : (
            <Loader2 className="size-4 animate-spin text-interaction" />
          )}
          {error ? 'Unable to load payment options.' : 'Loading payment options...'}
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          {error ? (
            <Button type="button" onClick={onRetry}>
              Try Again
            </Button>
          ) : null}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
